import { IInitialState } from 'src/store/initialState';

const cartSel = (state: IInitialState): IInitialState['cart'] => state.cart;

export const cartItemsSel = (state: IInitialState) => cartSel(state).items;
export const cartItemCountSel = (state: IInitialState) =>
  cartSel(state).itemCount;
export const cartDeliverMethodSel = (state: IInitialState) =>
  cartSel(state).delivery;
export const cartDeliveryLocationSel = (state: IInitialState) =>
  cartSel(state).deliveryLocation;
export const cartDeliverLocationCodeSel = (state: IInitialState) =>
  cartSel(state).deliveryLocationCode;
export const cartSuppliedFromCodeSel = (state: IInitialState) =>
  cartSel(state).suppliedFromCode;
export const cartSubtotalSel = (state: IInitialState) =>
  cartSel(state).subTotal;
export const cartIsPendingSel = (state: any) => cartSel(state).isPending;
export const cartUpdatingSel = (state: any) => cartSel(state).updating;
export const cartErrorSel = (state: any) => cartSel(state).error;
export const cartSuccessSel = (state: any) => cartSel(state).success;
export const cartisDownloadingPdfSel = (state: any) =>
  cartSel(state).isDownloadingPdf;
export const cartPendingListsSel = (state: any) => cartSel(state).isPendingList;
export const cartFileStatus = (state: any) => cartSel(state).isFileStatus;
